import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Template from '../views/Template.vue'
import Home from '../views/Home.vue'
import FilePreviewDemo from '../views/FilePreviewDemo.vue'

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/default/index.vue'),
    children: [
      { path: '/', redirect: '/home' },
      {
        path: '/writing',
        redirect: '/writing/step1'
      },
      {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
          title: '工作台',
          // permissions: []
        }
      },
      {
        path: '/writing',
        name: 'Writing',
        children: [
          {
            path: '/writing/step1',
            name: 'WritingStep1',
            component: () => import(/* webpackChunkName: "writing" */ '@/views/writing/Step1.vue'),
            meta: {
              title: '交底初核',
            }
          },
          {
            path: '/writing/step2',
            name: 'WritingStep2',
            component: () => import(/* webpackChunkName: "writing" */ '@/views/writing/Step2.vue'),
            meta: {
              title: '深度评审',
            }
          },
          {
            path: '/writing/step3',
            name: 'WritingStep3',
            component: () => import(/* webpackChunkName: "writing" */ '@/views/writing/Step3.vue'),
            meta: {
              hidden: true,
              title: '权利要求撰写',
            }
          },
          {
            path: '/writing/step4',
            name: 'WritingStep4',
            component: () => import(/* webpackChunkName: "writing" */ '@/views/writing/Step4.vue'),
            meta: {
              hidden: true,
              title: '说明书撰写',
            }
          },
          {
            path: '/writing/fullscreen',
            name: 'FullScreen',
            component: () => import(/* webpackChunkName: "writing" */ '@/views/FullScreen.vue'),
            meta: {
              hidden: true,
              title: '',
            }
          },
          {
            path: '/writing/novelty-search',
            name: 'NoveltySearch',
            component: () => import(/* webpackChunkName: "writing" */ '@/views/writing/NoveltySearch.vue'),
            meta: {
              hidden: true,
              title: '专业检索',
            }
          },
          {
            path: '/writing/template',
            name: 'WritingTemplate',
            component: Template,
            meta: {
              hidden: true,
              title: '模版'
            }
          },
        ]
      },
      {
        path: '/project',
        name: 'Project',
        component: () => import(/* webpackChunkName: "project" */ '@/views/Project.vue'),
        meta: {
          title: '全部项目',
          // permissions: []
        }
      },
      {
        path: '/401',
        component: () => import(/* webpackChunkName: "error" */ '@/views/error/401'),
        hidden: true
      },
      {
        path: '/404',
        component: () => import(/* webpackChunkName: "error" */ '@/views/error/404'),
        hidden: true
      },
      {
        path: '/file-preview-demo',
        name: 'FilePreviewDemo',
        component: FilePreviewDemo,
        meta: {
          title: '文件预览',
        }
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录'
    }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/writing/step3' || to.path === '/writing/step4') {
    next({ path: '/writing/step2', query: to.query, replace: true })
    return
  }
  if (to.path === '/writing/step5' || to.path.startsWith('/writing/step5/')) {
    next({ path: '/writing/step2', query: to.query, replace: true })
    return
  }
  document.title = to.meta.title || '交底书评估工作台'
  next()
})

export default router
